import React from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";
import CustomHeader from "../Header";
import { Layout } from "antd";
import { useTranslation } from "react-i18next";
import "./ResultSuccess.css";

const { Content } = Layout;

export default function ResultSuccess() {
  const { t } = useTranslation("user");
  return (
    <>
      <CustomHeader />
      <Content className="user-content-padding">
        <Result
          status="success"
          title={t("resultSuccess.title")}
          subTitle={t("resultSuccess.subTitle")}
          extra={[
            <Link to="/user/overview" key="overzicht">
              <Button className="touch-button" type="primary">{t("resultSuccess.toOverview")}</Button>
            </Link>,
            <Link to="/user/create-issue" key="newTicket">
              <Button className="touch-button">{t("resultSuccess.newTicket")}</Button>
            </Link>,
          ]}
        />
      </Content>
    </>
  );
}
